// extracted by mini-css-extract-plugin
export default {"loading":"LogoLoading-module--loading--d6283"};